import { FC } from 'react';
import { useHistory } from 'react-router-dom';
import { SupplierSummary } from '../../services/service-evaluations';
import { supplierEvaluationsUrl } from '../../util/evaluationsNavigation';
import SupplierEvaluationSummary from './SupplierEvaluationSummary';

type Props = {
  supplierId: string;
  readOnly: boolean;
  onStartEvaluation?: () => void;
  onAnswerHidden?: (summary: SupplierSummary) => void;
};

const SupplierEvaluationsTab: FC<Props> = ({
  supplierId,
  readOnly,
  onStartEvaluation,
  onAnswerHidden,
}) => {
  const history = useHistory();

  return (
    <SupplierEvaluationSummary
      supplierId={supplierId}
      readOnly={readOnly}
      onStartEvaluation={onStartEvaluation}
      onShowAll={() => history.push(supplierEvaluationsUrl(supplierId))}
      onAnswerHidden={onAnswerHidden}
    />
  );
};

export default SupplierEvaluationsTab;
